/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
import keyMirror from 'external/keymirror';

export default keyMirror({

    DATA_REMOVE: null,
    DATA_LIST_INIT: null,
    DATA_ITEM_INIT: null,
    DATA_INVALIDATE: null,

    DATA_REQUESTED: null,
    DATA_SUCCESS: null,
    DATA_ERROR: null,

    CREATE_ASYNC: null,
    UPDATE_ASYNC: null,
    DELETE_ASYNC: null,

    DATA_ASYNC: null,

    RESET_FORM: null,
    EDIT_IN_FORM: null,
    START_EDIT_IN_FORM: null,
    END_EDIT_IN_FORM: null,
    SUBMIT_FORM_ASYNC: null,

    MORE_ITEMS: null,

    DATA_UPDATE_MESSAGE: null,

    CONFIG_LOAD_ASYNC: null,
    CONFIG_UPDATE_ASYNC: null,
    CONFIG_SET: null,
    CONFIG_LOCAL_UPDATE: null,

    PAGE_SELECTED: null
});



// WEBPACK FOOTER //
// ./js/constants/ActionTypesCommon.js